import { createAsyncThunk } from '@reduxjs/toolkit';
import Api from '../api';

export const companyThunk = createAsyncThunk('company', async (id: number) => {
  return Api.get(`/companies/${id}`);
});
